/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { FormCountryMinimal } from './FormCountryMinimal';

export interface GetFormDataForRiderUserResponse {
    cities_by_countries: Array<FormCountryMinimal>;
    city_id_by_ip?: number;
    title: string;
    sub_title: string;
    country_label: string;
    city_label: string;
    terms_and_conditions_text: string;
    register_button_label: string;
    continue_registration_button_label: string;
    use_another_phone_email_button_label: string;
    review_contact_details_text: string;
    email: string;
    phone: string;
}
